// src/hooks/useSessionExpiry.js
import { useEffect, useRef, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { logout } from '../redux/authSlice';
import { msHastaExpiracion } from '../utils/jwt';

export default function useSessionExpiry() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = useSelector((s) => s.auth?.token);
  const timerRef = useRef(null);

  const cerrarSesion = useCallback(
    (porExpiracion = true) => {
      dispatch(logout());
      if (porExpiracion) {
        Swal.fire({
          icon: 'info',
          title: 'Sesión expirada',
          text: 'Tu sesión terminó por seguridad. Vuelve a iniciar sesión para continuar.',
          confirmButtonColor: '#d0021b',
        });
      }
      navigate('/login', { replace: true });
    },
    [dispatch, navigate]
  );

  useEffect(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }

    if (!token) return;

    const restante = msHastaExpiracion(token);
    if (restante === null) return;

    if (restante <= 0) {
      cerrarSesion(true);
      return;
    }

    timerRef.current = setTimeout(() => {
      cerrarSesion(true);
    }, restante);

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [token, cerrarSesion]);

  useEffect(() => {
    if (!token) return;

    const revisar = () => {
      const restante = msHastaExpiracion(token);
      if (restante !== null && restante <= 0) {
        cerrarSesion(true);
      }
    };

    const onVisible = () => {
      if (document.visibilityState === 'visible') revisar();
    };

    window.addEventListener('focus', revisar);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      window.removeEventListener('focus', revisar);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [token, cerrarSesion]);
}